import dayjs from 'dayjs';

const driverData = {
	name: {
		title: 'Nombre',
		nullText: 'No ingresado',
		data: '',
		id: 'name',
		validation: {
			valid: true,
			text: '',

		},
	},
	phone: {
		title: 'Teléfono',
		nullText: 'No ingresado',
		data: '',
		id: 'phone',
		type: 'number',
		validation: {
			valid: true,
			text: '',

		},
	},
	email: {
		title: 'Correo electrónico',
		nullText: 'No ingresado',
		data: '',
		id: 'email',
		validation: {
			valid: true,
			text: '',

		},
	},
	adress: {
		title: 'Dirección',
		nullText: 'No ingresada',
		data: '',
		id: 'adress',
		validation: {
			valid: true,
			text: '',

		},
	},
	commune: {
		title: 'Comuna',
		nullText: 'No ingresada',
		data: '',
		id: 'commune',
		type: 'select',
		validation: {
			valid: true,
			text: '',

		},
	},
};

const checkinLogin = {
	reservationNumber: {
		title: 'Número de reserva',
		nullText: 'No ingresado',
		data: '',
		id: 'reservationNumber',
		type: 'number',
		validation: {
			valid: true,
			text: '',

		},
	},
	authorizationCode: {
		title: 'Código de autorización',
		nullText: 'No ingresado',
		data: '',
		id: 'authorizationCode',
		validation: {
			valid: true,
			text: '',

		},
	},
};

const files = {
	cedulaAdelante: {
		title: 'Cédula frontal',
		nullText: 'No ingresado',
		data: '',
		id: 'cedulaAdelante',
		type: 'file',
		text: 'Suba su cédula frontal aquí',
		document: 'cedula',
		documentType: 'Adelante',
		source: '',
		size: {
			width: 0,
			height: 0
		},
		validation: {
			valid: true,
			text: '',

		},
	},
	cedulaPosterior: {
		title: 'Cédula posterior',
		nullText: 'No ingresado',
		data: '',
		id: 'cedulaPosterior',
		type: 'file',
		text: 'Suba su cédula posterior aquí',
		document: 'cedula',
		documentType: 'Posterior',
		source: '',
		size: {
			width: 0,
			height: 0
		},
		validation: {
			valid: true,
			text: '',

		},
	},
	birthday: {
		title: 'Fecha de nacimiento',
		nullText: 'No ingresada',
		data: dayjs(),
		id: 'birthday',
		type: 'date',
		document: 'cedula',
		validation: {
			valid: true,
			text: '',

		},
	},
	identityCardExpiration: {
		title: 'Expiración cédula',
		nullText: 'No ingresada',
		data: dayjs(),
		id: 'identityCardExpiration',
		type: 'date',
		document: 'cedula',
		validation: {
			valid: true,
			text: '',

		},
	},
	licenciaAdelante: {
		title: 'Licencia frontal',
		nullText: 'No ingresado',
		data: '',
		id: 'licenciaAdelante',
		type: 'file',
		text: 'Suba su licencia frontal aquí',
		document: 'licencia',
		documentType: 'Adelante',
		source: '',
		size: {
			width: 0,
			height: 0
		},
		validation: {
			valid: true,
			text: '',

		},
	},
	licenciaPosterior: {
		title: 'Licencia posterior',
		nullText: 'No ingresado',
		data: '',
		id: 'licenciaPosterior',
		type: 'file',
		text: 'Suba su licencia posterior aquí',
		document: 'licencia',
		documentType: 'Posterior',
		source: '',
		size: {
			width: 0,
			height: 0
		},
		validation: {
			valid: true,
			text: '',

		},
	},
	driveLicenseExpiration: {
		title: 'Expiración licencia',
		nullText: 'No ingresada',
		data: dayjs(),
		id: 'driveLicenseExpiration',
		type: 'date',
		document: 'licencia',
		validation: {
			valid: true,
			text: '',

		},
	},
};

const warranty = {
	titularTarjeta: {
		title: 'Titular de tarjeta',
		nullText: 'No ingresado',
		data: '',
		id: 'titularTarjeta',
		validation: {
			valid: true,
			text: '',

		},
	},
	numeroTarjeta: {
		title: 'Número de tarjeta',
		nullText: 'No ingresado',
		data: '',
		id: 'numeroTarjeta',
		type: 'number',
		validation: {
			valid: true,
			text: '',

		},
	},
	mesVencimiento: {
		title: 'Mes de vencimiento',
		nullText: 'No ingresado',
		data: '',
		id: 'mesVencimiento',
		type: 'date',
		format: 'year',
		validation: {
			valid: true,
			text: '0',

		},
	},
	anoVencimiento: {
		title: 'Año de vencimiento',
		nullText: 'No ingresado',
		data: '',
		id: 'anoVencimiento',
		type: 'date',
		format: 'year',
		validation: {
			valid: true,
			text: '0',

		},
	},
};

const consent = {
	condiciones: {
		title: 'Acepto términos y condiciones',
		nullText: 'No ingresado',
		data: false,
		id: 'condiciones',
		type: 'checkbox',
		validation: {
			valid: true,
			text: '',

		},
	},
	datosVeridicos: {
		title: 'Confirmo que los datos subidos son verídicos',
		nullText: 'No ingresado',
		data: false,
		id: 'datosVeridicos',
		type: 'checkbox',
		validation: {
			valid: true,
			text: '',

		},
	},
};


const exampleFileForm = {
	examplefile: {
		title: 'Example File',
		nullText: 'No ingresado',
		data: '',
		id: 'examplefile',
		type: 'file',
		text: 'Suba su imagen aquí',
		validation: {
			valid: true,
			text: '',

		},
	},
};

export default {
	login: {
		title: 'Check in login',
		checkinLogin:{
			form: checkinLogin,
			key: 'checkinLogin',
			title: 'Ingreso al check in',
			editable: false,
		},
	},
	checkin1: {
		title: 'Datos de conductor',
		driverData:{
			form: driverData,
			key: 'driverData',
			title: 'Datos de conductor',
			editable: false,
		},
	},
	checkin2: {
		title: 'Documentos y garantía',
		files:{
			form: files,
			key: 'files',
			title: 'Carga de documentos',
			editable: false,
			selectedFile: 'cedulaAdelante',
			nextFile: '',
		},
		warranty:{
			form: warranty,
			key: 'warranty',
			title: 'Datos de garantía',
			editable: false,
		},
		consent:{
			form: consent,
			key: 'consent',
			title: 'Consentimiento y vericidad',
			editable: false,
		},
	},
	test: {
		title: 'Datos de conductor',
		exampleFileForm:{
			form: exampleFileForm,
			key: 'exampleFileForm',
			title: 'Formulario ejemplo subida archivo',
			editable: false,
		},
	},
};